import React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'
import IconTooltipButton from '../../../../../button/IconTooltipButton'
import { Badge, ListItemIcon } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SSOList = ({ list = [], isLoading, permissions, onModal }) => {
  if (isLoading) {
    return (
      <List>
        { Array(4).fill().map((_, i) => (
          <ListItem key={i}>
            <ListItemIcon>
              <Skeleton variant="circular" width='2rem' height='2rem' />
            </ListItemIcon>
            <ListItemText 
              primary={<Skeleton variant='text' width={300} />} 
              secondary={<Skeleton variant='text' width={200} />} 
            />
          </ListItem>
        ))}
      </List>
    );
  }
  if (list.length === 0) return <Typography variant='inherit' component={'p'} className='text-muted-foreground opacity-50 py-2 px-2'>You don't have any service yet</Typography>
  return (
    <List>
      { list.map((item) => (
        <ListItem button key={item._id} >
          <ListItemIcon>
          <Badge color={item.isEnabled ? 'primary' : 'inherit'} badgeContent="Active" variant="dot">
            {item?.service === 'google' && <i className='btn-icon btn-icon-google'></i>}
            {item?.service === 'microsoft' && <i className='btn-icon btn-icon-microsoft'></i>}
            {item?.service === 'facebook' && <i className='btn-icon btn-icon-facebook'></i>}
            {item?.service === 'apple' && <i className='btn-icon btn-icon-apple'></i>}
            {item?.service === 'cloudwork' && <FontAwesomeIcon className='text-3xl ' icon={['fas', 'users-rays']} />}
          </Badge>
            
          </ListItemIcon>
          <ListItemText 
            primary={item?.name}
            secondary={item?.service}
            classes={{ secondary: 'uppercase' }}
          />
          <ListItemSecondaryAction>
            { permissions['preview'] && <IconTooltipButton title='Preview' icon='expand-alt' onClick={() => onModal('preview', item)}  />}
            { permissions['updated'] && <IconTooltipButton title='Edit' icon={['fas', 'edit']} onClick={() => onModal('edit', item)} />}
            { permissions['deleted'] && <IconTooltipButton title='Delete' icon={['fas', 'trash-alt']} onClick={() => onModal('delete', item)} />}
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  )
}

export default SSOList